import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src1855149980/src/comici-magazine/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1855149980/src/comici-magazine/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["GOT_LOGIN_BONUS_COOKIE_NAME"] */ "/codebuild/output/src1855149980/src/comici-magazine/src/app/components/AnalyticLogger.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1855149980/src/comici-magazine/src/styles/common.css");
